import type React from "react";

import { faEllipsis } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { CancelIcon } from "assets";

import { OptionItem, StyledDropDownButton } from "./components/PatientHeaderDropdownStyles";

interface Props {
  toggleEndTreatment: () => void;
}

export const PatientHeaderInfoShowMoreButton: React.FC<Props> = ({ toggleEndTreatment }) => {
  const { t } = useTranslation();

  return (
    <StyledDropDownButton
      id="extra-button"
      options={[
        {
          children: (
            <OptionItem>
              <CancelIcon />
              <div>{t("patients.header_info.end_treatment_button")}</div>
            </OptionItem>
          ),
          onClick: toggleEndTreatment,
          dataTestId: "button-end-treatment-forms",
        },
      ]}
      dropdownOrigin="right"
      dataTestId="extra-button"
    >
      <FontAwesomeIcon icon={faEllipsis} style={{ height: "16px", width: "16px", margin: "0px" }} />
    </StyledDropDownButton>
  );
};
